export { default } from './RichText'
